import React from 'react';
import makeStyles from '@material-ui/core/styles/makeStyles';
import Typography from '@material-ui/core/Typography';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import Tooltip from '@material-ui/core/Tooltip';
import { transparentize } from 'polished';
import classNames from 'classnames';
import FormHelperText from '@material-ui/core/FormHelperText';
import { SettingItemOptions } from './typings';

interface Props {
  title: string;
  subTitle: string;
  value: any;
  options: SettingItemOptions;
  disabled?: boolean;
  tooltipContent?: string;
  errorMessage?: any;
  onChange: (e: any) => void;
}

function SettingItem({
  title,
  subTitle,
  value,
  options,
  disabled,
  tooltipContent,
  errorMessage,
  onChange,
}: Props) {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <div className={classes.container}>
        <Typography
          variant="body1"
          className={classNames(classes.title, disabled && classes.disabled)}
        >
          {title}
        </Typography>
        <Typography variant="subtitle2" className={classNames(disabled && classes.disabled)}>
          {subTitle}
        </Typography>
      </div>
      <Tooltip arrow placement="top" title={disabled && tooltipContent ? tooltipContent : ''}>
        <div className={classes.selectContainer}>
          <Select
            variant="outlined"
            value={value}
            className={classes.select}
            onChange={e => onChange(e)}
            error={!!errorMessage}
            disabled={disabled}
          >
            {options.map(item => (
              <MenuItem value={item.value.toString()}>{item.displayName}</MenuItem>
            ))}
          </Select>
          {errorMessage && <FormHelperText error>{errorMessage}</FormHelperText>}
        </div>
      </Tooltip>
    </div>
  );
}

const useStyles = makeStyles(theme => {
  const WIDTH = 317;

  return {
    root: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      paddingLeft: theme.spacing(3),
      paddingRight: theme.spacing(3),
      marginBottom: theme.spacing(4),
    },
    container: {
      maxWidth: 750,
    },
    disabled: {
      color: transparentize(0.62, theme.palette.common.black),
    },
    title: {
      // @ts-ignore
      fontWeight: theme.typography.fontWeightSemiBold,
    },
    selectContainer: {
      minWidth: WIDTH,
    },
    select: {
      maxWidth: WIDTH,
      width: '100%',
    },
  };
});

export default SettingItem;
